export default {
  awaitingReview: 'awaitingReview', // The ticket is awaiting a review.
  pendingChange: 'pendingChange', // The ticket has a pending change.
  confirmed: 'confirmed', // The ticket has been approved.
  closed: 'closed', // The ticket is closed.
};



// WEBPACK FOOTER //
// ./src/utils/ticketStatusConstants.js